import React from 'react';
import { AtlassianIcon } from '@atlaskit/logo';
import { AvatarCircleSkeleton, AvatarWrapper } from '../../avatar-layout';
var AtlassianAvatarContainer = function AtlassianAvatarContainer() {
  return /*#__PURE__*/React.createElement(AvatarWrapper, {
    "data-testid": "avatar-wrapper"
  }, /*#__PURE__*/React.createElement(AvatarCircleSkeleton, {
    size: "var(--ds-space-500, 40px)",
    bgColor: "transparent"
  }, /*#__PURE__*/React.createElement(AtlassianIcon, {
    size: "medium",
    appearance: "brand"
  })));
};
export default AtlassianAvatarContainer;